.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-sm);
  min-height: var(--hit-target);
  padding: 0 var(--spacing-lg);
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  transition:
    background-color var(--transition-fast),
    border-color var(--transition-fast);
}

.button:disabled {
  color: var(--color-text-disabled);
}

.primary {
  background: var(--color-primary);
  color: var(--color-on-primary);
}

.primary:hover:not(:disabled) {
  background: var(--color-primary-hover);
}

.primary:disabled {
  background: var(--color-surface-hover);
}

.secondary {
  background: var(--color-surface);
  border-color: var(--color-border-strong);
  color: var(--color-text);
}

.secondary:hover:not(:disabled) {
  background: var(--color-surface-hover);
}

.ghost {
  background: transparent;
  color: var(--color-text);
}

.ghost:hover:not(:disabled) {
  background: var(--color-surface-hover);
}
